exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#accordion__HeadingChar.is-expanded {\r\n  -webkit-transform: rotate(-180deg);\r\n  transform: rotate(-180deg);\r\n}\r\n\r\n#accordion__HeadingChar {\r\n  content: \"\\2304\";\r\n  font-size: 1.8em;\r\n  float: right;\r\n  transition: -webkit-transform 0.3s ease-in-out;\r\n  transition: transform 0.3s ease-in-out;\r\n  transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;\r\n  position: relative;\r\n  top: -10px;\r\n  height: 20px;\r\n  width: 20px;\r\n  cursor: pointer;\r\n  transform-origin: center 25px;\r\n  -webkit-transform-origin: center 25px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/integration/integration.component.css
// module id = ../../../../../src/app/integration/integration.component.css
// module chunks = 5